import { isVisibleFieldInTab } from '@/views/pages/require/handlers';
import { surnameAddressPhoneNumber } from '@/views/pages/require/constants';

const SWITCH_FIELD_TAB_1 = (dataObject, preview = true) => {
    return {
        格納場所: isVisibleFieldInTab(
            {
                storage_site: dataObject.storage_site,
                file_name: dataObject.file_name,
                free_block_storage_location: dataObject.free_block_storage_location
            },
            preview
        ),
        WEB管理画面: isVisibleFieldInTab(
            {
                web_management_screen: dataObject.web_management_screen,
                free_block_web_management: dataObject.free_block_web_management
            },
            preview
        ),
        SNSアカウント: isVisibleFieldInTab(
            {
                social_media_account: dataObject.social_media_account,
                free_block_social_media: dataObject.free_block_social_media
            },
            preview
        ),
        Lターゲット: isVisibleFieldInTab(
            {
                cr_supporter: dataObject.cr_supporter,
                free_block_cr_supporter: dataObject.free_block_cr_supporter
            },
            preview
        )
    };
};

const SWITCH_FIELD_TAB_2 = (dataObject, preview = true) => {
    return {
        宛先: isVisibleFieldInTab(
            {
                address: dataObject.address
            },
            preview
        ),
        '■CP概要その他先_2': isVisibleFieldInTab(
            {
                free_block_campaign_overview: dataObject.free_block_campaign_overview
            },
            preview
        ),
        '■応募数報告その他先_2': isVisibleFieldInTab(
            {
                free_block_report_number: dataObject.free_block_report_number
            },
            preview
        ),
        報告スケジュール: isVisibleFieldInTab(
            {
                reporting_schedule: dataObject.reporting_schedule,
                reporting_schedule_detail: dataObject.reporting_schedule_detail
            },
            preview
        ),
        仕分け方法: isVisibleFieldInTab(
            {
                sorting_method: dataObject.sorting_method
            },
            preview
        ),
        無効内容の詳細: isVisibleFieldInTab(
            {
                invalid_content: dataObject.invalid_content
            },
            preview
        ),
        報告内容: isVisibleFieldInTab(
            {
                contents_of_report: dataObject.contents_of_report,
                contents_of_report_detail: dataObject.contents_of_report_detail,
                contents_of_report_expiration_date: dataObject.contents_of_report_expiration_date
            },
            preview
        ),
        その他連絡事項: isVisibleFieldInTab(
            {
                other_information: dataObject.other_information
            },
            preview
        ),
        フリーブロックその他先: isVisibleFieldInTab(
            {
                free_block_other: dataObject.free_block_other
            },
            preview
        )
    };
};

const SWITCH_FIELD_TAB_3 = (dataObject, preview = true) => {
    return {
        ...SWITCH_FIELD_TAB_2(dataObject, preview),
        '■CP概要その他先_3': isVisibleFieldInTab(
            {
                free_block_campaign_overview: dataObject.free_block_campaign_overview
            },
            preview
        ),
        '■応募数報告その他先_3': isVisibleFieldInTab(
            {
                free_block_report_number: dataObject.free_block_report_number
            },
            preview
        ),
        応募フォーム: isVisibleFieldInTab(
            {
                registration_form: dataObject.registration_form
            },
            preview
        ),
        報告内容: isVisibleFieldInTab(
            {
                contents_of_report: dataObject.contents_of_report,
                contents_of_report_detail: dataObject.contents_of_report_detail
            },
            preview
        ),
        テスト応募: isVisibleFieldInTab(
            {
                test_application_1: dataObject.test_application_1,
                test_application_2: dataObject.test_application_2
            },
            preview
        )
    };
};

const SWITCH_FIELD_TAB_4 = (dataObject, preview = true) => {
    return {
        ...SWITCH_FIELD_TAB_2(dataObject, preview),
        '■CP概要その他先_4': isVisibleFieldInTab(
            {
                free_block_campaign_overview: dataObject.free_block_campaign_overview
            },
            preview
        ),
        '■応募数報告その他先_4': isVisibleFieldInTab(
            {
                free_block_report_number: dataObject.free_block_report_number
            },
            preview
        ),
        SNS: isVisibleFieldInTab(
            {
                sns: dataObject.sns
            },
            preview
        ),
        ツール: isVisibleFieldInTab(
            {
                collection_tools: dataObject.collection_tools
            },
            preview
        ),
        'ンペーン名（ATELUのみ）': isVisibleFieldInTab(
            {
                campaign_name_atelu_only: dataObject.campaign_name_atelu_only
            },
            preview
        ),
        収集対象タグ: isVisibleFieldInTab(
            {
                tag_collected: dataObject.tag_collected
            },
            preview
        ),
        報告内容: isVisibleFieldInTab(
            {
                contents_of_report: dataObject.contents_of_report,
                contents_of_report_detail: dataObject.contents_of_report_detail
            },
            preview
        ),
        テスト応募: isVisibleFieldInTab(
            {
                test_application_1: dataObject.test_application_1,
                test_application_2: dataObject.test_application_2,
                test_application_3: dataObject.test_application_3
            },
            preview
        )
    };
};

const SWITCH_FIELD_TAB_5 = (dataObject, preview = true) => {
    return {
        ...SWITCH_FIELD_TAB_2(dataObject, preview),
        ...SWITCH_FIELD_TAB_4(dataObject, preview),
        '■CP概要その他先_5': isVisibleFieldInTab(
            {
                free_block_campaign_overview: dataObject.free_block_campaign_overview
            },
            preview
        ),
        '■応募数報告その他先_5': isVisibleFieldInTab(
            {
                free_block_report_number: dataObject.free_block_report_number
            },
            preview
        ),
        '収集対象投稿(URL)': isVisibleFieldInTab(
            {
                post_to_be_collected_word: dataObject.post_to_be_collected_word,
                post_to_be_collected_url: dataObject.post_to_be_collected_url
            },
            preview
        ),
        ディレクション確認内容: isVisibleFieldInTab(
            {
                confirm_detail_direction: dataObject.confirm_detail_direction
            },
            preview
        )
    };
};

const SWITCH_FIELD_TAB_6 = (dataObject, preview = true) => {
    return {
        ...SWITCH_FIELD_TAB_2(dataObject, preview),
        ...SWITCH_FIELD_TAB_3(dataObject, preview),
        '■CP概要その他先_6': isVisibleFieldInTab(
            {
                free_block_campaign_overview: dataObject.free_block_campaign_overview
            },
            preview
        ),
        '■応募数報告その他先_6': isVisibleFieldInTab(
            {
                free_block_report_number: dataObject.free_block_report_number
            },
            preview
        ),
        Lタゲ内該当キャンペーンID: isVisibleFieldInTab(
            {
                campaign_name_in_cr: dataObject.campaign_name_in_cr
            },
            preview
        ),
        通数作成時の日時項目: isVisibleFieldInTab(
            {
                date_end_time_field: dataObject.date_end_time_field
            },
            preview
        ),
        テスト応募: isVisibleFieldInTab(
            {
                test_application: dataObject.test_application
            },
            preview
        )
    };
};

const SWITCH_FIELD_TAB_7 = (dataObject, preview = true) => {
    return {
        ...SWITCH_FIELD_TAB_2(dataObject, preview),
        賞品: isVisibleFieldInTab(dataObject.data, preview),
        対象データ: isVisibleFieldInTab(
            {
                target_file: dataObject.target_file
            },
            preview
        ),
        '■期間条件': isVisibleFieldInTab(
            {
                period_conditions_lottery: dataObject.period_conditions_lottery,
                period_conditions_postcard: dataObject.period_conditions_postcard
            },
            preview
        ),
        抽選対象期間: isVisibleFieldInTab(
            {
                period_conditions_lottery: dataObject.period_conditions_lottery
            },
            preview
        ),
        '消印有効日（ハガキ）': isVisibleFieldInTab(
            {
                period_conditions_postcard: dataObject.period_conditions_postcard
            },
            preview
        ),
        抽選方法: isVisibleFieldInTab(
            {
                lottery_method: dataObject.lottery_method
            },
            preview
        ),
        当選条件: isVisibleFieldInTab(
            {
                winning_conditions: dataObject.winning_conditions,
                winning_condition_detail: dataObject.winning_condition_detail
            },
            preview
        ),
        重複条件: isVisibleFieldInTab(
            {
                prize_overlap: dataObject.prize_overlap
            },
            preview
        ),
        比率指定有無: isVisibleFieldInTab(
            {
                ratio_specification_1: dataObject.ratio_specification_1,
                ratio_specification_2: dataObject.ratio_specification_2,
                ratio_specification_3: dataObject.ratio_specification_3
            },
            preview
        ),
        クイズ回答内容確認: isVisibleFieldInTab(
            {
                confirm_quiz_answer_details: dataObject.confirm_quiz_answer_details
            },
            preview
        ),
        その他アンケート条件など: isVisibleFieldInTab(
            {
                other_survey_conditions_etc: dataObject.other_survey_conditions_etc
            },
            preview
        ),
        その他条件: isVisibleFieldInTab(
            {
                other_conditions: dataObject.other_conditions
            },
            preview
        ),
        同一世帯: isVisibleFieldInTab(
            {
                same_household_1: dataObject.same_household_1,
                same_household_2: dataObject.same_household_2
            },
            preview
        ),
        同一人物: isVisibleFieldInTab(
            {
                same_person_1: dataObject.same_person_1,
                same_person_2: dataObject.same_person_2
            },
            preview
        ),
        確認項目_7_check1: isVisibleFieldInTab(
            {
                same_household_1: dataObject.same_household_1
            },
            preview
        ),
        確認条件_7_check1: isVisibleFieldInTab(
            {
                same_household_2: dataObject.same_household_2
            },
            preview
        ),
        確認項目_7_check2: isVisibleFieldInTab(
            {
                same_person_1: dataObject.same_person_1
            },
            preview
        ),
        確認条件_7_check2: isVisibleFieldInTab(
            {
                same_person_2: dataObject.same_person_2
            },
            preview
        ),
        確認項目_7_check3: isVisibleFieldInTab(
            {
                others_duplicate_1: dataObject.others_duplicate_1
            },
            preview
        ),
        確認条件_7_check3: isVisibleFieldInTab(
            {
                others_duplicate_2: dataObject.others_duplicate_2
            },
            preview
        ),
        確認項目_7_check4: isVisibleFieldInTab(
            {
                unique_id_1: dataObject.unique_id_1
            },
            preview
        ),
        確認条件_7_check4: isVisibleFieldInTab(
            {
                unique_id_2: dataObject.unique_id_2
            },
            preview
        ),
        '＜重複チェック＞その他': isVisibleFieldInTab(
            {
                others_duplicate_1: dataObject.others_duplicate_1,
                others_duplicate_2: dataObject.others_duplicate_2
            },
            preview
        ),
        固有ID: isVisibleFieldInTab(
            {
                unique_id_1: dataObject.unique_id_1,
                unique_id_2: dataObject.unique_id_2
            },
            preview
        ),
        その他データとの付け合わせ確認: isVisibleFieldInTab(
            {
                matching_with_other_data_1: dataObject.matching_with_other_data_1,
                matching_with_other_data_2: dataObject.matching_with_other_data_2
            },
            preview
        ),
        名前不備確認: isVisibleFieldInTab(
            {
                confirm_error_name: dataObject.confirm_error_name
            },
            preview
        ),
        住所不備確認: isVisibleFieldInTab(
            {
                address_verification_1: dataObject.address_verification_1,
                address_verification_2: dataObject.address_verification_2
            },
            preview
        ),
        電話番号不備確認: isVisibleFieldInTab(
            {
                confirm_phone_number_is_incomplete: dataObject.confirm_phone_number_is_incomplete
            },
            preview
        ),
        メールアドレス不備確認: isVisibleFieldInTab(
            {
                confirm_email_address_is_incomplete: dataObject.confirm_email_address_is_incomplete
            },
            preview
        ),
        '＜不備チェック＞その他': isVisibleFieldInTab(
            {
                other_errors: dataObject.other_errors
            },
            preview
        ),
        '＜抽選条件＞その他先_7': isVisibleFieldInTab(
            {
                free_block_lottery_condition: dataObject.free_block_lottery_condition
            },
            preview
        ),
        '＜重複チェック＞その他先_7': isVisibleFieldInTab(
            {
                free_block_duplicate_check: dataObject.free_block_duplicate_check
            },
            preview
        )
    };
};

const SWITCH_FIELD_TAB_8 = (dataObject, preview = true) => {
    return {
        ...SWITCH_FIELD_TAB_7(dataObject, preview),
        重複条件: isVisibleFieldInTab(
            {
                prize_overlap: dataObject.prize_overlap,
                cross_distribution_overlap: dataObject.cross_distribution_overlap
            },
            preview
        ),
        賞品またぎ重複: isVisibleFieldInTab(
            {
                prize_overlap: dataObject.prize_overlap
            },
            preview
        ),
        流通またぎ重複: isVisibleFieldInTab(
            {
                cross_distribution_overlap: dataObject.cross_distribution_overlap
            },
            preview
        ),
        購入日: isVisibleFieldInTab(
            {
                purchase_date: dataObject.purchase_date
            },
            preview
        ),
        対象商品: isVisibleFieldInTab(
            {
                shipping: dataObject.shipping
            },
            preview
        ),
        '購入条件（金額・個数）': isVisibleFieldInTab(
            {
                purchase_price: dataObject.purchase_price
            },
            preview
        ),
        '購入店舗・流通': isVisibleFieldInTab(
            {
                purchase_store_or_distribution: dataObject.purchase_store_or_distribution
            },
            preview
        ),
        '＜購買チェック＞その他': isVisibleFieldInTab(
            {
                purchase_info_other: dataObject.purchase_info_other
            },
            preview
        ),
        確認項目_8_check1: isVisibleFieldInTab(
            {
                same_household_1: dataObject.same_household_1
            },
            preview
        ),
        確認条件_8_check1: isVisibleFieldInTab(
            {
                same_household_2: dataObject.same_household_2
            },
            preview
        ),
        確認項目_8_check2: isVisibleFieldInTab(
            {
                same_person_1: dataObject.same_person_1
            },
            preview
        ),
        確認条件_8_check2: isVisibleFieldInTab(
            {
                same_person_2: dataObject.same_person_2
            },
            preview
        ),
        確認項目_8_check3: isVisibleFieldInTab(
            {
                others_duplicate_1: dataObject.others_duplicate_1
            },
            preview
        ),
        確認条件_8_check3: isVisibleFieldInTab(
            {
                others_duplicate_2: dataObject.others_duplicate_2
            },
            preview
        ),
        確認項目_8_check4: isVisibleFieldInTab(
            {
                unique_id_1: dataObject.unique_id_1
            },
            preview
        ),
        確認条件_8_check4: isVisibleFieldInTab(
            {
                unique_id_2: dataObject.unique_id_2
            },
            preview
        ),
        '＜抽選条件＞その他先_8': isVisibleFieldInTab(
            {
                free_block_lottery_condition: dataObject.free_block_lottery_condition
            },
            preview
        ),
        '＜重複チェック＞その他先_8': isVisibleFieldInTab(
            {
                free_block_duplicate_check: dataObject.free_block_duplicate_check
            },
            preview
        ),
        '＜不備チェック＞その他先_8': isVisibleFieldInTab(
            {
                free_block_deficiency_check: dataObject.free_block_deficiency_check
            },
            preview
        )
    };
};

const SWITCH_FIELD_TAB_9 = (dataObject, preview = true) => {
    return {
        ...SWITCH_FIELD_TAB_7(dataObject, preview),
        ...SWITCH_FIELD_TAB_8(dataObject, preview),
        ハッシュタグ: isVisibleFieldInTab(dataObject.data, preview),
        対象ファイル: isVisibleFieldInTab(
            {
                target_file: dataObject.target_file
            },
            preview
        ),
        '期間条件（抽選対象期間）': isVisibleFieldInTab(
            {
                period_conditions: dataObject.period_conditions
            },
            preview
        ),
        除外アカウント: isVisibleFieldInTab(
            {
                excluded_accounts: dataObject.excluded_accounts
            },
            preview
        ),
        'アカウント・投稿情報': isVisibleFieldInTab(
            {
                official_account_follow_check: dataObject.official_account_follow_check,
                number_of_followers: dataObject.number_of_followers,
                number_of_follower_detail: dataObject.number_of_follower_detail,
                number_of_posts: dataObject.number_of_posts,
                number_of_post_detail: dataObject.number_of_post_detail,
                required_words_in_the_post: dataObject.required_words_in_the_post,
                post_word_count: dataObject.post_word_count
            },
            preview
        ),
        公式アカウントフォローチェック: isVisibleFieldInTab(
            {
                official_account_follow_check: dataObject.official_account_follow_check
            },
            preview
        ),
        フォロワー数: isVisibleFieldInTab(
            {
                number_of_followers: dataObject.number_of_followers,
                number_of_follower_detail: dataObject.number_of_follower_detail
            },
            preview
        ),
        投稿数: isVisibleFieldInTab(
            {
                number_of_posts: dataObject.number_of_posts,
                number_of_post_detail: dataObject.number_of_post_detail
            },
            preview
        ),
        投稿内必須ワード: isVisibleFieldInTab(
            {
                required_words_in_the_post: dataObject.required_words_in_the_post
            },
            preview
        ),
        投稿文文字数: isVisibleFieldInTab(
            {
                post_word_count: dataObject.post_word_count
            },
            preview
        ),
        指定条件: isVisibleFieldInTab(
            {
                specified_condition_1: dataObject.specified_condition_1,
                specified_condition_2: dataObject.specified_condition_2,
                specified_condition_3: dataObject.specified_condition_3
            },
            preview
        ),
        確認件数: isVisibleFieldInTab(
            {
                number_of_confirmed_cases_1: dataObject.number_of_confirmed_cases_1,
                number_of_confirmed_cases_2: dataObject.number_of_confirmed_cases_2
            },
            preview
        ),
        '＜画像検閲＞その他条件（別資料）': isVisibleFieldInTab(
            {
                others_conditions: dataObject.others_conditions
            },
            preview
        ),
        '＜重複・懸賞チェック＞重複条件': isVisibleFieldInTab(
            {
                overlapping_conditions_account_id: dataObject.overlapping_conditions_account_id
            },
            preview
        ),
        その他確認項目: isVisibleFieldInTab(
            {
                other_items_to_check: dataObject.other_items_to_check
            },
            preview
        ),
        懸賞確認: isVisibleFieldInTab(
            {
                account_name: dataObject.account_name,
                specified_keywords: dataObject.specified_keywords,
                profile_statement: dataObject.profile_statement,
                presence_of_specified_keyword: dataObject.presence_of_specified_keyword,
                check_the_latest_posts_1: dataObject.check_the_latest_posts_1,
                check_the_latest_posts_2: dataObject.check_the_latest_posts_2,
                check_the_latest_posts_3: dataObject.check_the_latest_posts_3
            },
            preview
        ),
        'アカウント名\n指定キーワード有無': isVisibleFieldInTab(
            {
                account_name: dataObject.account_name,
                specified_keywords: dataObject.specified_keywords
            },
            preview
        ),
        'プロフィール文言\n指定キーワード有無': isVisibleFieldInTab(
            {
                profile_statement: dataObject.profile_statement,
                presence_of_specified_keyword: dataObject.presence_of_specified_keyword
            },
            preview
        ),
        直近の投稿内容: isVisibleFieldInTab(
            {
                check_the_latest_posts_1: dataObject.check_the_latest_posts_1,
                check_the_latest_posts_2: dataObject.check_the_latest_posts_2,
                check_the_latest_posts_3: dataObject.check_the_latest_posts_3
            },
            preview
        ),
        '＜重複・懸賞チェック＞その他条件（別資料）': isVisibleFieldInTab(
            {
                other_condition_prize_check: dataObject.other_condition_prize_check
            },
            preview
        ),
        '＜重複・照合チェック＞': isVisibleFieldInTab(
            {
                matching_items: dataObject.matching_items,
                condition_maching: dataObject.condition_maching,
                condition_maching_data: dataObject.condition_maching_data,
                overlap_condition_id_1: dataObject.overlap_condition_id_1,
                overlap_condition_id_2: dataObject.overlap_condition_id_2,
                overlap_condition_same_house_1: dataObject.overlap_condition_same_house_1,
                overlap_condition_same_house_2: dataObject.overlap_condition_same_house_2,
                overlap_condition_same_person_1: dataObject.overlap_condition_same_person_1,
                overlap_condition_same_preson_2: dataObject.overlap_condition_same_preson_2,
                overlap_condition_others: dataObject.overlap_condition_others
            },
            preview
        ),
        照合項目: isVisibleFieldInTab(
            {
                matching_items: dataObject.matching_items
            },
            preview
        ),
        照合条件: isVisibleFieldInTab(
            {
                condition_maching: dataObject.condition_maching,
                condition_maching_data: dataObject.condition_maching_data
            },
            preview
        ),
        '＜重複・照合チェック＞重複条件': isVisibleFieldInTab(
            {
                overlap_condition_id_1: dataObject.overlap_condition_id_1,
                overlap_condition_id_2: dataObject.overlap_condition_id_2,
                overlap_condition_same_house_1: dataObject.overlap_condition_same_house_1,
                overlap_condition_same_house_2: dataObject.overlap_condition_same_house_2,
                overlap_condition_same_person_1: dataObject.overlap_condition_same_person_1,
                overlap_condition_same_preson_2: dataObject.overlap_condition_same_preson_2
            },
            preview
        ),
        指定ID: isVisibleFieldInTab(
            {
                overlap_condition_id_1: dataObject.overlap_condition_id_1,
                overlap_condition_id_2: dataObject.overlap_condition_id_2
            },
            preview
        ),
        同一世帯_9: isVisibleFieldInTab(
            {
                overlap_condition_same_house_1: dataObject.overlap_condition_same_house_1,
                overlap_condition_same_house_2: dataObject.overlap_condition_same_house_2
            },
            preview
        ),
        同一人物_9: isVisibleFieldInTab(
            {
                overlap_condition_same_person_1: dataObject.overlap_condition_same_person_1,
                overlap_condition_same_preson_2: dataObject.overlap_condition_same_preson_2
            },
            preview
        ),
        '＜重複・照合チェック＞その他条件': isVisibleFieldInTab(
            {
                overlap_condition_others: dataObject.overlap_condition_others
            },
            preview
        ),
        '＜抽選条件＞その他先_9': isVisibleFieldInTab(
            {
                free_block_lottery_condition: dataObject.free_block_lottery_condition
            },
            preview
        ),
        '＜画像検閲＞その他先_9': isVisibleFieldInTab(
            {
                free_block_image_censorship: dataObject.free_block_image_censorship
            },
            preview
        ),
        '＜重複・懸賞チェック＞その他先_9': isVisibleFieldInTab(
            {
                free_block_duplicate_prize_check: dataObject.free_block_duplicate_prize_check
            },
            preview
        ),
        '＜条件チェック＞その他先_9': isVisibleFieldInTab(
            {
                free_block_condition_check: dataObject.free_block_condition_check
            },
            preview
        ),
        '＜重複・照合チェック＞その他先_9': isVisibleFieldInTab(
            { free_block_duplicate_collation_check: dataObject.free_block_duplicate_collation_check },
            preview
        ),
        '＜条件チェック＞対象ファイル': isVisibleFieldInTab(
            {
                target_file_status_check: dataObject.target_file_status_check
            },
            preview
        ),
        '＜条件チェック＞期間条件（抽出対象期間）': isVisibleFieldInTab(
            {
                period_conditions_extracted: dataObject.period_conditions_extracted
            },
            preview
        ),
        '＜条件チェック＞最終納品データの形指定有無': isVisibleFieldInTab(
            {
                specifies_the_data_format: dataObject.specifies_the_data_format,
                specifies_the_data_format_detail: dataObject.specifies_the_data_format_detail
            },
            preview
        ),
        '＜条件チェック＞その他条件': isVisibleFieldInTab(
            {
                other_conditions_status_check: dataObject.other_conditions_status_check
            },
            preview
        )
    };
};

const SWITCH_FIELD_TAB_10 = (dataObject, preview = true) => {
    return {
        ...SWITCH_FIELD_TAB_9(dataObject, preview),
        'アカウント・投稿情報': isVisibleFieldInTab(
            {
                official_account_follow_check_1: dataObject.official_account_follow_check_1,
                official_account_follow_check_2: dataObject.official_account_follow_check_2,
                number_of_followers: dataObject.number_of_followers,
                number_of_follower_detail: dataObject.number_of_follower_detail,
                number_of_posts: dataObject.number_of_posts,
                number_of_post_detail: dataObject.number_of_post_detail,
                number_of_likes: dataObject.number_of_likes,
                number_of_like_detail: dataObject.number_of_like_detail,
                required_words_in_the_post: dataObject.required_words_in_the_post,
                post_word_count: dataObject.post_word_count
            },
            preview
        ),
        公式アカウントフォローチェック: isVisibleFieldInTab(
            {
                official_account_follow_check_1: dataObject.official_account_follow_check_1,
                official_account_follow_check_2: dataObject.official_account_follow_check_2
            },
            preview
        ),
        フォロワー数: isVisibleFieldInTab(
            {
                number_of_followers: dataObject.number_of_followers,
                number_of_follower_detail: dataObject.number_of_follower_detail
            },
            preview
        ),
        いいね数: isVisibleFieldInTab(
            {
                number_of_likes: dataObject.number_of_likes,
                number_of_like_detail: dataObject.number_of_like_detail
            },
            preview
        ),
        同一世帯_10: isVisibleFieldInTab(
            {
                overlap_condition_same_house_1: dataObject.overlap_condition_same_house_1,
                overlap_condition_same_house_2: dataObject.overlap_condition_same_house_2
            },
            preview
        ),
        同一人物_10: isVisibleFieldInTab(
            {
                overlap_condition_same_person_1: dataObject.overlap_condition_same_person_1,
                overlap_condition_same_preson_2: dataObject.overlap_condition_same_preson_2
            },
            preview
        ),
        直近投稿内容確認: isVisibleFieldInTab(
            {
                check_the_latest_posts_1: dataObject.check_the_latest_posts_1,
                check_the_latest_posts_2: dataObject.check_the_latest_posts_2,
                check_the_latest_posts_3: dataObject.check_the_latest_posts_3
            },
            preview
        ),
        '＜抽選条件＞その他先_10': isVisibleFieldInTab(
            {
                free_block_lottery_condition: dataObject.free_block_lottery_condition
            },
            preview
        ),
        '＜画像検閲＞その他先_10': isVisibleFieldInTab(
            {
                free_block_image_censorship: dataObject.free_block_image_censorship
            },
            preview
        ),
        '＜重複・懸賞チェック＞その他先_10': isVisibleFieldInTab(
            {
                free_block_duplicate_prize_check: dataObject.free_block_duplicate_prize_check
            },
            preview
        ),
        '＜条件チェック＞その他先_10': isVisibleFieldInTab(
            {
                free_block_condition_check: dataObject.free_block_condition_check
            },
            preview
        ),
        '＜重複・照合チェック＞その他先_10': isVisibleFieldInTab(
            { free_block_duplicate_collation_check: dataObject.free_block_duplicate_collation_check },
            preview
        )
    };
};

const SWITCH_FIELD_TAB_11 = (dataObject, preview = true) => {
    return {
        ...SWITCH_FIELD_TAB_9(dataObject, preview),
        抽選方法: isVisibleFieldInTab(
            {
                lottery_method: dataObject.lottery_method,
                lottery_method_detail: dataObject.lottery_method_detail
            },
            preview
        ),
        ダウンロード: isVisibleFieldInTab(
            {
                campaign_id_record: dataObject.campaign_id_record,
                campaign_title: dataObject.campaign_title
            },
            preview
        ),
        キャンペーンID: isVisibleFieldInTab(
            {
                campaign_id_record: dataObject.campaign_id_record
            },
            preview
        ),
        キャンペーンタイトル: isVisibleFieldInTab(
            {
                campaign_title: dataObject.campaign_title
            },
            preview
        ),
        応募有効期間: isVisibleFieldInTab(
            {
                application_validity_period: dataObject.application_validity_period
            },
            preview
        ),
        重複条件: isVisibleFieldInTab(
            {
                prize_winning: dataObject.prize_winning,
                cross_application_form: dataObject.cross_application_form
            },
            preview
        ),
        賞品またぎ: isVisibleFieldInTab(
            {
                prize_winning: dataObject.prize_winning
            },
            preview
        ),
        応募形態またぎ: isVisibleFieldInTab(
            {
                cross_application_form: dataObject.cross_application_form
            },
            preview
        ),
        比率指定: isVisibleFieldInTab(
            {
                ratio_specification: dataObject.ratio_specification,
                ratio_specification_detail: dataObject.ratio_specification_detail
            },
            preview
        ),
        その他条件: isVisibleFieldInTab(
            {
                other_conditions: dataObject.other_conditions,
                other_condition_detail: dataObject.other_condition_detail
            },
            preview
        ),
        '＜不備チェック＞その他': isVisibleFieldInTab(
            {
                other_errors: dataObject.other_errors,
                other_error_detail: dataObject.other_error_detail
            },
            preview
        ),
        購入有効期間: isVisibleFieldInTab(
            {
                purchase_validity_period: dataObject.purchase_validity_period
            },
            preview
        ),
        対象商品: isVisibleFieldInTab(
            {
                shipping: dataObject.shipping
            },
            preview
        ),
        購入条件: isVisibleFieldInTab(
            {
                purchase_conditions: dataObject.purchase_conditions
            },
            preview
        ),
        '＜購買チェック＞その他': isVisibleFieldInTab(
            {
                purchase_info_other: dataObject.purchase_info_other,
                purchase_info_other_detail: dataObject.purchase_info_other_detail
            },
            preview
        ),
        同一世帯: isVisibleFieldInTab(
            {
                same_household_1: dataObject.same_household_1,
                same_household_2: dataObject.same_household_2,
                same_household_type: dataObject.same_household_type
            },
            preview
        ),
        確認項目_同一世帯_11: isVisibleFieldInTab(
            {
                same_household_type: dataObject.same_household_type,
                same_household_1: dataObject.same_household_1
            },
            preview
        ),
        確認条件: isVisibleFieldInTab(
            {
                same_household_2: dataObject.same_household_2
            },
            preview
        ),
        同一人物: isVisibleFieldInTab(
            {
                same_person_1: dataObject.same_person_1,
                same_person_2: dataObject.same_person_2,
                same_person_type: dataObject.same_person_type
            },
            preview
        ),
        確認項目_同一人物_11: isVisibleFieldInTab(
            {
                same_person_type: dataObject.same_person_type,
                same_person_1: dataObject.same_person_1
            },
            preview
        ),
        確認条件_同一人物_11: isVisibleFieldInTab(
            {
                same_person_2: dataObject.same_person_2
            },
            preview
        ),
        '＜重複チェック＞その他': isVisibleFieldInTab(
            {
                others_duplicate_1: dataObject.others_duplicate_1,
                others_duplicate_2: dataObject.others_duplicate_2,
                others_duplicate: dataObject.others_duplicate
            },
            preview
        ),
        '確認項目_＜重複チェック＞その他_11': isVisibleFieldInTab(
            {
                others_duplicate: dataObject.others_duplicate,
                others_duplicate_1: dataObject.others_duplicate_1
            },
            preview
        ),
        '確認条件_＜重複チェック＞その他_11': isVisibleFieldInTab(
            {
                others_duplicate_2: dataObject.others_duplicate_2
            },
            preview
        ),
        '＜抽選条件＞その他先_11': isVisibleFieldInTab(
            {
                free_block_lottery_condition: dataObject.free_block_lottery_condition
            },
            preview
        ),
        '＜重複チェック＞その他先_11': isVisibleFieldInTab(
            {
                free_block_duplicate_check: dataObject.free_block_duplicate_check
            },
            preview
        ),
        '＜不備チェック＞その他先_11': isVisibleFieldInTab(
            {
                free_block_deficiency_check: dataObject.free_block_deficiency_check
            },
            preview
        )
    };
};

const DEFAULT_TEXTAREA_CONFIG = {
    minHeight: 37,
    isInputAutoSize: true
};

const configHelperOptions = {
    optionTab2: {
        address: ['直住所', '私書箱', 'その他'],
        reporting_schedule: ['週報', '月報', '最終一括', 'その他イレギュラー'],
        contents_of_report: ['週別応募件数', '賞別応募件数', '有効無効応募件数']
    },
    optionTab3: {
        registration_form: ['エイジア', 'きわメル', 'WEBin', 'クライアント支給'],
        reporting_schedule: ['週報', '月報', '最終一括', 'その他'],
        contents_of_report: ['日別応募件数', '週別応募件数', '賞別応募件数', '有効無効応募件数']
    },
    optionTab4: {
        collection_tools: ['キャンつく', 'タグ取る', 'ATERU', 'クライアント支給ツール'],
        reporting_schedule: ['週報', '月報', '最終一括', 'その他イレギュラー'],
        contents_of_report: ['日別応募件数', '週別応募件数', '賞別応募件数', '有効無効応募件数']
    },
    optionTab5: {
        collection_tools: ['キャンつく', 'ATERU', 'クライアント支給ツール'],
        reporting_schedule: ['週報', '月報', '最終一括', 'その他イレギュラー'],
        contents_of_report: ['日別応募件数', '週別応募件数', '対象投稿別応募件数']
    },
    optionTab6: {
        reporting_schedule: ['週報', '月報', '最終一括', 'その他'],
        contents_of_report: ['日別応募件数', '週別応募件数', '賞別応募件数', '有効無効応募件数']
    },
    optionTab7: {
        lottery_method: ['データ抽選', 'ハガキ引き抜き'],
        target_file: [
            'camｰpasフォーム',
            'WEBCASフォーム',
            'タナカ印刷フォーム',
            'シナジーフォーム',
            'その他フォーム',
            'Lターゲット',
            'ATELUデータ',
            'その他SNSツールデータ',
            'HP入力データ',
            '先方支給データ'
        ],
        winning_conditions: ['特になし', 'クイズに正解している人', 'アンケートに回答している人', 'その他'],
        prize_overlap: ['重複確認する', '重複確認しない'],
        cross_distribution_overlap: ['重複確認する', '重複確認しない'],
        ratio_specification_1: ['あり', 'なし', 'その他'],
        ratio_specification_2: ['賞品', '応募形態', '口数', '流通・店舗', '都道府県', '年齢', '性別', 'アンケート回答'],
        same_household_2: ['完全一致', ' 近似値目チェック'],
        same_person_2: ['完全一致', ' 近似値目チェック'],
        others_duplicate_2: ['完全一致', ' 近似値目チェック'],
        unique_id_2: ['完全一致', ' 近似値目チェック'],
        matching_with_other_data_1: ['あり', 'なし'],
        address_verification_2: ['システムチェック', '近似値目チェック']
    },
    optionTab8: {
        lottery_method: ['データ抽選', 'ハガキ引き抜き'],
        target_file: [
            'camｰpasフォーム',
            'WEBCASフォーム',
            'タナカ印刷フォーム',
            'シナジーフォーム',
            'その他フォーム',
            'Lターゲット',
            'HP入力データ',
            '先方支給データ'
        ],
        winning_conditions: ['クイズに正解している人', 'アンケートに回答している人', 'その他'],
        prize_overlap: ['重複確認する', '重複確認しない'],
        cross_distribution_overlap: ['重複確認する', '重複確認しない'],
        ratio_specification_1: ['あり', 'なし'],
        ratio_specification_2: ['賞品', '応募形態', '口数', '流通・店舗', '都道府県', '年齢', '性別', 'アンケート回答'],
        same_household_2: ['完全一致', ' 近似値目チェック'],
        same_person_2: ['完全一致', ' 近似値目チェック'],
        others_duplicate_2: ['完全一致', ' 近似値目チェック'],
        unique_id_2: ['完全一致', ' 近似値目チェック'],
        matching_with_other_data_1: ['あり', 'なし'],
        address_verification_2: ['システムチェック', '近似値目チェック']
    },
    optionTab9: {
        official_account_follow_check: ['なし', 'あり(データで確認可能)', 'あり(目チェック)'],
        target_file: ['キャンつく', 'ATELU', '支給データ'],
        number_of_followers: ['あり　データ確認', 'あり　目視確認'],
        number_of_posts: ['あり　データ確認', 'あり　目視確認'],
        account_name: ['なし', 'あり(データで確認可能)', 'あり(目チェック)'],
        profile_statement: ['なし', 'あり(データで確認可能)', 'あり(目チェック)'],
        target_file_status_check: ['エイジアフォーム', 'その他フォーム', '支給データ'],
        specifies_the_data_format: ['あり', 'なし'],
        matching_items: ['アカウントID', '当選ID', 'なし'],
        condition_maching: ['なし', 'あり(フォーム照合機能あり)', 'あり(フォーム照合機能なし)'],
        condition_maching_data: ['完全一致', '近似値目チェック'],
        overlap_condition_id_1: ['指定ID', '●●'],
        overlap_condition_id_2: ['完全一致', '近似値目チェック'],
        overlap_condition_same_house_2: ['完全一致', '近似値目チェック'],
        overlap_condition_same_preson_2: ['完全一致', '近似値目チェック'],
        address_verification_2: ['システムチェック', '近似値目チェック']
    },
    optionTab10: {
        official_account_follow_check: ['なし', 'あり(データで確認可能)', 'あり(目チェック)'],
        target_file: ['キャンつく', 'ATELU', '支給データ'],
        number_of_followers: ['なし', 'あり(データで確認可能)', 'あり(目チェック)'],
        number_of_posts: ['あり　データ確認', 'あり　目視確認'],
        number_of_likes: ['あり　データ確認', 'あり　目視確認'],
        account_name: ['なし', 'あり(データで確認可能)', 'あり(目チェック)'],
        profile_statement: ['なし', 'あり(データで確認可能)', 'あり(目チェック)'],
        target_file_status_check: ['エイジアフォーム', 'その他フォーム', '支給データ'],
        specifies_the_data_format: ['あり', 'なし'],
        matching_items: ['アカウントID', '当選ID', 'なし'],
        condition_maching: ['なし', 'あり(フォーム照合機能あり)', 'あり(フォーム照合機能なし)'],
        condition_maching_data: ['完全一致', '近似値目チェック'],
        overlap_condition_id_1: ['指定ID', '●●'],
        overlap_condition_id_2: ['完全一致', '近似値目チェック'],
        overlap_condition_same_house_2: ['完全一致', '近似値目チェック'],
        overlap_condition_same_preson_2: ['完全一致', '近似値目チェック'],
        address_verification_2: ['システムチェック', '近似値目チェック']
    },
    optionTab11: {
        lottery_method: ['データ抽選', 'ハガキ引き抜き'],
        prize_winning: ['重複確認する', '重複確認しない '],
        cross_application_form: ['重複確認する', '重複確認しない'],
        cross_distribution: ['重複確認する', '重複確認しない'],
        ratio_specification: ['なし', '賞品', '応募形態', '口数', '流通・店舗', '都道府県', '年齢', '性別', 'アンケート回答', 'その他'],
        other_conditions: ['あり', 'なし'],
        same_household_1: ['住所', '住所＋苗字', '住所＋電話番号', surnameAddressPhoneNumber],
        same_household_2: ['完全一致', '近似値目チェック'],
        same_household_type: ['あり', 'なし'],
        same_person_1: ['名前', '住所', '電話番号', 'メールアドレス', 'アカウント・ID', surnameAddressPhoneNumber],
        same_person_2: ['完全一致', '近似値目チェック'],
        same_person_type: ['あり', 'なし'],
        others_duplicate_2: ['完全一致', '近似値目チェック'],
        others_duplicate: ['あり', 'なし'],
        address_verification_2: ['システムチェック', '近似値目チェック'],
        other_errors: ['あり', 'なし'],
        purchase_store_or_distribution: ['あり', 'なし'],
        purchase_info_other: ['あり', 'なし']
    },
    optionPostcard: [
        'camｰpasフォーム',
        'WEBCASフォーム',
        'タナカ印刷フォーム',
        'シナジーフォーム',
        'その他フォーム',
        'HP入力データ',
        '先方支給データ'
    ]
};

const CONFIG_INPUT_TAB_1 = () => {
    return {
        storage_site: { type: 'text', placeholder: '' },
        file_name: { type: 'text', placeholder: '' },
        web_management_screen: {
            analytic_form_url_out: {
                $each: {
                    data: DEFAULT_TEXTAREA_CONFIG
                }
            }
        },

        social_media_account: { ...DEFAULT_TEXTAREA_CONFIG, minHeight: 115 },
        cr_supporter: { ...DEFAULT_TEXTAREA_CONFIG, minHeight: 115 }
    };
};

const CONFIG_INPUT_TAB_2 = () => {
    return {
        reporting_schedule: { type: 'text', placeholder: '' },
        reporting_schedule_detail: DEFAULT_TEXTAREA_CONFIG,
        sorting_method: DEFAULT_TEXTAREA_CONFIG,
        contents_of_report_detail: DEFAULT_TEXTAREA_CONFIG,
        contents_of_report_expiration_date: DEFAULT_TEXTAREA_CONFIG,
        invalid_content: DEFAULT_TEXTAREA_CONFIG,
        other_information: DEFAULT_TEXTAREA_CONFIG
    };
};

const CONFIG_INPUT_TAB_3 = () => {
    return {
        reporting_schedule_detail: DEFAULT_TEXTAREA_CONFIG,
        contents_of_report_detail: DEFAULT_TEXTAREA_CONFIG,
        test_application_1: DEFAULT_TEXTAREA_CONFIG,
        test_application_2: DEFAULT_TEXTAREA_CONFIG,
        invalid_content: DEFAULT_TEXTAREA_CONFIG,
        other_information: DEFAULT_TEXTAREA_CONFIG
    };
};

const CONFIG_INPUT_TAB_4 = () => {
    return {
        reporting_schedule: { type: 'text', placeholder: '' },
        sns: DEFAULT_TEXTAREA_CONFIG,
        collection_tools: DEFAULT_TEXTAREA_CONFIG,
        campaign_name_atelu_only: DEFAULT_TEXTAREA_CONFIG,
        tag_collected: DEFAULT_TEXTAREA_CONFIG,
        reporting_schedule_detail: DEFAULT_TEXTAREA_CONFIG,
        contents_of_report_detail: DEFAULT_TEXTAREA_CONFIG,
        test_application_1: DEFAULT_TEXTAREA_CONFIG,
        test_application_2: DEFAULT_TEXTAREA_CONFIG,
        test_application_3: DEFAULT_TEXTAREA_CONFIG,
        invalid_content: DEFAULT_TEXTAREA_CONFIG,
        other_information: DEFAULT_TEXTAREA_CONFIG
    };
};

const CONFIG_INPUT_TAB_5 = () => {
    return {
        reporting_schedule: { type: 'text', placeholder: '' },
        sns: DEFAULT_TEXTAREA_CONFIG,
        collection_tools: DEFAULT_TEXTAREA_CONFIG,
        campaign_name_atelu_only: DEFAULT_TEXTAREA_CONFIG,
        tag_collected: DEFAULT_TEXTAREA_CONFIG,
        reporting_schedule_detail: DEFAULT_TEXTAREA_CONFIG,
        contents_of_report_twitter_rt: DEFAULT_TEXTAREA_CONFIG,
        contents_of_report_detail: DEFAULT_TEXTAREA_CONFIG,
        post_to_be_collected_word: DEFAULT_TEXTAREA_CONFIG,
        post_to_be_collected_url: DEFAULT_TEXTAREA_CONFIG,
        test_application_1: DEFAULT_TEXTAREA_CONFIG,
        test_application_2: DEFAULT_TEXTAREA_CONFIG,
        test_application_3: DEFAULT_TEXTAREA_CONFIG,
        invalid_content: DEFAULT_TEXTAREA_CONFIG,
        other_information: DEFAULT_TEXTAREA_CONFIG,
        confirm_detail_direction: DEFAULT_TEXTAREA_CONFIG
    };
};

const CONFIG_INPUT_TAB_6 = () => {
    return {
        registration_form: DEFAULT_TEXTAREA_CONFIG,
        campaign_name_in_cr: DEFAULT_TEXTAREA_CONFIG,
        reporting_schedule_detail: DEFAULT_TEXTAREA_CONFIG,
        contents_of_report_detail: DEFAULT_TEXTAREA_CONFIG,
        date_end_time_field: DEFAULT_TEXTAREA_CONFIG,
        test_application: DEFAULT_TEXTAREA_CONFIG,
        invalid_content: DEFAULT_TEXTAREA_CONFIG,
        other_information: DEFAULT_TEXTAREA_CONFIG
    };
};

const CONFIG_INPUT_TAB_7 = () => {
    return {
        num: { type: 'number', isNumber: true },
        write_freely: DEFAULT_TEXTAREA_CONFIG,
        winning_condition_detail: DEFAULT_TEXTAREA_CONFIG,
        ratio_specification_3: DEFAULT_TEXTAREA_CONFIG,
        confirm_quiz_answer_details: DEFAULT_TEXTAREA_CONFIG,
        other_survey_conditions_etc: DEFAULT_TEXTAREA_CONFIG,
        other_conditions: DEFAULT_TEXTAREA_CONFIG,
        same_household_1: DEFAULT_TEXTAREA_CONFIG,
        same_person_1: DEFAULT_TEXTAREA_CONFIG,
        others_duplicate_1: DEFAULT_TEXTAREA_CONFIG,
        unique_id_1: DEFAULT_TEXTAREA_CONFIG,
        matching_with_other_data_2: DEFAULT_TEXTAREA_CONFIG,
        confirm_error_name: DEFAULT_TEXTAREA_CONFIG,
        address_verification_1: DEFAULT_TEXTAREA_CONFIG,
        confirm_phone_number_is_incomplete: DEFAULT_TEXTAREA_CONFIG,
        confirm_email_address_is_incomplete: DEFAULT_TEXTAREA_CONFIG,
        other_errors: DEFAULT_TEXTAREA_CONFIG
    };
};

const CONFIG_INPUT_TAB_8 = () => {
    return {
        num: { type: 'number', isNumber: true },
        write_freely: DEFAULT_TEXTAREA_CONFIG,
        ratio_specification_3: DEFAULT_TEXTAREA_CONFIG,
        other_conditions: DEFAULT_TEXTAREA_CONFIG,
        same_household_1: DEFAULT_TEXTAREA_CONFIG,
        same_person_1: DEFAULT_TEXTAREA_CONFIG,
        others_duplicate_1: DEFAULT_TEXTAREA_CONFIG,
        unique_id_1: DEFAULT_TEXTAREA_CONFIG,
        matching_with_other_data_2: DEFAULT_TEXTAREA_CONFIG,
        confirm_error_name: DEFAULT_TEXTAREA_CONFIG,
        address_verification_1: DEFAULT_TEXTAREA_CONFIG,
        confirm_phone_number_is_incomplete: DEFAULT_TEXTAREA_CONFIG,
        confirm_email_address_is_incomplete: DEFAULT_TEXTAREA_CONFIG,
        other_errors: DEFAULT_TEXTAREA_CONFIG,
        shipping: DEFAULT_TEXTAREA_CONFIG,
        purchase_price: DEFAULT_TEXTAREA_CONFIG,
        purchase_store_or_distribution: DEFAULT_TEXTAREA_CONFIG,
        purchase_info_other: DEFAULT_TEXTAREA_CONFIG
    };
};

const CONFIG_INPUT_TAB_9 = () => {
    return {
        num: { type: 'number', isNumber: true },
        write_freely: DEFAULT_TEXTAREA_CONFIG,
        lottery_method: DEFAULT_TEXTAREA_CONFIG,
        excluded_accounts: DEFAULT_TEXTAREA_CONFIG,
        number_of_follower_detail: DEFAULT_TEXTAREA_CONFIG,
        number_of_post_detail: DEFAULT_TEXTAREA_CONFIG,
        required_words_in_the_post: DEFAULT_TEXTAREA_CONFIG,
        post_word_count: DEFAULT_TEXTAREA_CONFIG,
        other_conditions: DEFAULT_TEXTAREA_CONFIG,
        specified_condition_1: DEFAULT_TEXTAREA_CONFIG,
        specified_condition_2: DEFAULT_TEXTAREA_CONFIG,
        specified_condition_3: DEFAULT_TEXTAREA_CONFIG,
        number_of_confirmed_cases_1: DEFAULT_TEXTAREA_CONFIG,
        number_of_confirmed_cases_2: DEFAULT_TEXTAREA_CONFIG,
        others_conditions: DEFAULT_TEXTAREA_CONFIG,
        image_censorship_conditions: DEFAULT_TEXTAREA_CONFIG,
        target_file: DEFAULT_TEXTAREA_CONFIG,
        specified_keyword_presence: DEFAULT_TEXTAREA_CONFIG,
        inappropriate_content_presence: DEFAULT_TEXTAREA_CONFIG,
        inappropriate_account_presence: DEFAULT_TEXTAREA_CONFIG,
        mention_presence: DEFAULT_TEXTAREA_CONFIG,
        presence_of_link: DEFAULT_TEXTAREA_CONFIG,
        video_image_censorship_1: DEFAULT_TEXTAREA_CONFIG,
        video_image_censorship_2: DEFAULT_TEXTAREA_CONFIG,
        video_image_censorship_3: DEFAULT_TEXTAREA_CONFIG,
        video_image_censorship_4: DEFAULT_TEXTAREA_CONFIG,
        video_image_censorship_5: DEFAULT_TEXTAREA_CONFIG,
        overlapping_conditions_account_id: DEFAULT_TEXTAREA_CONFIG,
        other_items_to_check: DEFAULT_TEXTAREA_CONFIG,
        specified_keywords: DEFAULT_TEXTAREA_CONFIG,
        presence_of_specified_keyword: DEFAULT_TEXTAREA_CONFIG,
        check_the_latest_posts_1: DEFAULT_TEXTAREA_CONFIG,
        check_the_latest_posts_2: DEFAULT_TEXTAREA_CONFIG,
        check_the_latest_posts_3: DEFAULT_TEXTAREA_CONFIG,
        other_condition_prize_check: DEFAULT_TEXTAREA_CONFIG,
        specifies_the_data_format_detail: DEFAULT_TEXTAREA_CONFIG,
        other_conditions_status_check: DEFAULT_TEXTAREA_CONFIG,
        condition_maching_data: DEFAULT_TEXTAREA_CONFIG,
        overlap_condition_same_house_1: DEFAULT_TEXTAREA_CONFIG,
        overlap_condition_same_person_1: DEFAULT_TEXTAREA_CONFIG,
        overlap_condition_others: DEFAULT_TEXTAREA_CONFIG,
        confirm_error_name: DEFAULT_TEXTAREA_CONFIG,
        address_verification_1: DEFAULT_TEXTAREA_CONFIG,
        confirm_phone_number_is_incomplete: DEFAULT_TEXTAREA_CONFIG,
        confirm_email_address_is_incomplete: DEFAULT_TEXTAREA_CONFIG,
        other_errors: DEFAULT_TEXTAREA_CONFIG
    };
};

const CONFIG_INPUT_TAB_10 = () => {
    return {
        num: { type: 'number', isNumber: true },
        write_freely: {
            ...DEFAULT_TEXTAREA_CONFIG,
            placeholder: '※対象のハッシュタグ情報などこの賞に振り分けられる条件などあれば記載'
        },
        excluded_accounts: DEFAULT_TEXTAREA_CONFIG,
        number_of_follower_detail: DEFAULT_TEXTAREA_CONFIG,
        number_of_post_detail: DEFAULT_TEXTAREA_CONFIG,
        number_of_like_detail: DEFAULT_TEXTAREA_CONFIG,
        required_words_in_the_post: DEFAULT_TEXTAREA_CONFIG,
        post_word_count: DEFAULT_TEXTAREA_CONFIG,
        other_conditions: DEFAULT_TEXTAREA_CONFIG,
        specified_condition_3: DEFAULT_TEXTAREA_CONFIG,
        official_account_follow_check_1: DEFAULT_TEXTAREA_CONFIG,
        specified_condition_1: DEFAULT_TEXTAREA_CONFIG,
        number_of_confirmed_cases_1: DEFAULT_TEXTAREA_CONFIG,
        number_of_confirmed_cases_2: DEFAULT_TEXTAREA_CONFIG,
        extraction_target_period_1: DEFAULT_TEXTAREA_CONFIG,
        specified_post_check_1: DEFAULT_TEXTAREA_CONFIG,
        official_account_follow_check_2: DEFAULT_TEXTAREA_CONFIG,
        specified_condition_2: DEFAULT_TEXTAREA_CONFIG,
        presence_of_specified_hashtag_1: DEFAULT_TEXTAREA_CONFIG,
        mention_check_1: DEFAULT_TEXTAREA_CONFIG,
        tag_check_1: DEFAULT_TEXTAREA_CONFIG,
        specified_post_check_2: DEFAULT_TEXTAREA_CONFIG,
        image_content_check_1: DEFAULT_TEXTAREA_CONFIG,
        image_content_check_2: DEFAULT_TEXTAREA_CONFIG,
        others_conditions: DEFAULT_TEXTAREA_CONFIG,
        overlapping_conditions_account_id: DEFAULT_TEXTAREA_CONFIG,
        other_items_to_check: DEFAULT_TEXTAREA_CONFIG,
        specified_keywords: DEFAULT_TEXTAREA_CONFIG,
        presence_of_specified_keyword: DEFAULT_TEXTAREA_CONFIG,
        check_the_latest_posts_1: DEFAULT_TEXTAREA_CONFIG,
        check_the_latest_posts_2: DEFAULT_TEXTAREA_CONFIG,
        check_the_latest_posts_3: DEFAULT_TEXTAREA_CONFIG,
        other_condition_prize_check: DEFAULT_TEXTAREA_CONFIG,
        specifies_the_data_format_detail: DEFAULT_TEXTAREA_CONFIG,
        other_conditions_status_check: DEFAULT_TEXTAREA_CONFIG,
        condition_maching_data: DEFAULT_TEXTAREA_CONFIG,
        overlap_condition_same_house_1: DEFAULT_TEXTAREA_CONFIG,
        overlap_condition_same_person_1: DEFAULT_TEXTAREA_CONFIG,
        overlap_condition_others: DEFAULT_TEXTAREA_CONFIG,
        confirm_error_name: DEFAULT_TEXTAREA_CONFIG,
        address_verification_1: DEFAULT_TEXTAREA_CONFIG,
        confirm_phone_number_is_incomplete: DEFAULT_TEXTAREA_CONFIG,
        confirm_email_address_is_incomplete: DEFAULT_TEXTAREA_CONFIG,
        other_errors: DEFAULT_TEXTAREA_CONFIG
    };
};

const CONFIG_INPUT_TAB_11 = () => {
    return {
        num: { type: 'number', isNumber: true },
        write_freely: DEFAULT_TEXTAREA_CONFIG,
        lottery_method_detail: DEFAULT_TEXTAREA_CONFIG,
        campaign_id_record: DEFAULT_TEXTAREA_CONFIG,
        campaign_title: DEFAULT_TEXTAREA_CONFIG,
        ratio_specification_detail: DEFAULT_TEXTAREA_CONFIG,
        other_condition_detail: DEFAULT_TEXTAREA_CONFIG,
        others_duplicate_1: DEFAULT_TEXTAREA_CONFIG,
        confirm_error_name: DEFAULT_TEXTAREA_CONFIG,
        address_verification_1: DEFAULT_TEXTAREA_CONFIG,
        confirm_phone_number_is_incomplete: DEFAULT_TEXTAREA_CONFIG,
        confirm_email_address_is_incomplete: DEFAULT_TEXTAREA_CONFIG,
        other_error_detail: DEFAULT_TEXTAREA_CONFIG,
        shipping: DEFAULT_TEXTAREA_CONFIG,
        purchase_conditions: DEFAULT_TEXTAREA_CONFIG,
        purchase_store_or_distribution: DEFAULT_TEXTAREA_CONFIG,
        purchase_info_other_detail: DEFAULT_TEXTAREA_CONFIG
    };
};

export {
    configHelperOptions,
    SWITCH_FIELD_TAB_1,
    SWITCH_FIELD_TAB_2,
    SWITCH_FIELD_TAB_3,
    SWITCH_FIELD_TAB_4,
    SWITCH_FIELD_TAB_5,
    SWITCH_FIELD_TAB_6,
    SWITCH_FIELD_TAB_7,
    SWITCH_FIELD_TAB_8,
    SWITCH_FIELD_TAB_9,
    SWITCH_FIELD_TAB_10,
    SWITCH_FIELD_TAB_11,
    CONFIG_INPUT_TAB_1,
    CONFIG_INPUT_TAB_2,
    CONFIG_INPUT_TAB_3,
    CONFIG_INPUT_TAB_4,
    CONFIG_INPUT_TAB_5,
    CONFIG_INPUT_TAB_6,
    CONFIG_INPUT_TAB_7,
    CONFIG_INPUT_TAB_8,
    CONFIG_INPUT_TAB_9,
    CONFIG_INPUT_TAB_10,
    CONFIG_INPUT_TAB_11,
    CONFIG_ROWSPAN_TAB_7,
    CONFIG_ROWSPAN_TAB_8,
    CONFIG_ROWSPAN_TAB_9,
    CONFIG_ROWSPAN_TAB_10,
    CONFIG_ROWSPAN_TAB_11
};

const CONFIG_ROWSPAN_TAB_7 = {
    '■期間条件': {
        base: 1,
        fields: {
            '消印有効日（ハガキ）': 1
        }
    },
    同一世帯: {
        base: 1,
        fields: {
            確認条件_7_check1: 1
        }
    },
    同一人物: {
        base: 1,
        fields: {
            確認条件_7_check2: 1
        }
    },
    '＜重複チェック＞その他': {
        base: 1,
        fields: {
            確認条件_7_check3: 1
        }
    },
    固有ID: {
        base: 1,
        fields: {
            確認条件_7_check4: 1
        }
    }
};
const CONFIG_ROWSPAN_TAB_8 = {
    ...CONFIG_ROWSPAN_TAB_7,
    重複条件: {
        base: 1,
        fields: {
            流通またぎ重複: 1
        }
    },
    同一世帯: {
        base: 1,
        fields: {
            確認条件_8_check1: 1
        }
    },
    同一人物: {
        base: 1,
        fields: {
            確認条件_8_check2: 1
        }
    },
    '＜重複チェック＞その他': {
        base: 1,
        fields: {
            確認条件_8_check3: 1
        }
    },
    固有ID: {
        base: 1,
        fields: {
            確認条件_8_check4: 1
        }
    }
};

const CONFIG_ROWSPAN_TAB_9 = {
    'アカウント・投稿情報': {
        base: 1,
        fields: {
            フォロワー数: 2,
            投稿数: 2,
            投稿内必須ワード: 1,
            投稿文文字数: 1
        }
    },
    懸賞確認: {
        base: 1,
        fields: {
            'アカウント名\n指定キーワード有無': 1,
            'プロフィール文言\n指定キーワード有無': 2,
            直近の投稿内容: 3
        }
    },
    '＜重複・照合チェック＞重複条件': {
        base: 1,
        fields: {
            指定ID: 1,
            同一世帯_9: 2,
            同一人物_9: 2
        }
    }
};

const CONFIG_ROWSPAN_TAB_10 = {
    ...CONFIG_ROWSPAN_TAB_9,
    'アカウント・投稿情報': {
        base: 1,
        fields: {
            公式アカウントフォローチェック: 1,
            フォロワー数: 2,
            投稿数: 2,
            いいね数: 2,
            投稿内必須ワード: 1,
            投稿文文字数: 1
        }
    },
    '＜重複・照合チェック＞重複条件': {
        base: 1,
        fields: {
            指定ID: 1,
            同一世帯_10: 2,
            同一人物_10: 2
        }
    }
};
const CONFIG_ROWSPAN_TAB_11 = {
    ダウンロード: {
        base: 1,
        fields: {
            キャンペーンタイトル: 1
        }
    },
    重複条件: {
        base: 1,
        fields: {
            応募形態またぎ: 1
        }
    },
    同一世帯: {
        base: 1,
        fields: {
            確認条件: 1
        }
    },
    同一人物: {
        base: 1,
        fields: {
            確認条件_同一人物_11: 1
        }
    },
    '＜重複チェック＞その他': {
        base: 1,
        fields: {
            '確認条件_＜重複チェック＞その他_11': 1
        }
    }
};
